import { NotificationThresholds } from 'modules/settings/components/custom-notifications/custom-notification-threshold.model';
export const CUSTOM_NOTIFICATION_NAME_MAX_LENGTH = 255;

export const MINIMUM_MONITORING_PERIOD_DAYS = 1;

export const MAXIMUM_MONITORING_PERIOD_DAYS = 999999999;

export const MINIMUM_OCCURRENCES = 1;

export const MAXIMUM_OCCURRENCES = 999999999;

export const DEFAULT_MONITORING_PERIOD_DAYS = '30';

export const DEFAULT_NOTIFICATION_THRESHOLDS: NotificationThresholds = {
    gray: { enabled: false, numberOfEvents: null },
    yellow: { enabled: false, numberOfEvents: null },
    red: { enabled: false, numberOfEvents: null },
};
